import Splide from '@splidejs/splide';
import JsTabs from 'js-tabs';
import Detail from '@assets/product/detail';
import computedStyle from '../../utils/computedStyle';
import math from '../../utils/math';
import calculate from '../../utils/calculate';
import progress from '../../components/progress';
import listener from '../../utils/listener';
import image from '../../utils/image';
import update from '../../utils/update';
import { arrowPath } from '../../components/carousel';
import Zoom from '../../components/zoom';

import QuickView from '../product/quickView';

document.addEventListener('DOMContentLoaded', (e) => {
  new QuickView().init();
});

export default class extends Detail {
  constructor() {
    super();
    this.isQuickViewShown = $('#quickViewModal').length > 0 && $('#quickViewModal').hasClass('show');
    const $root = this.isQuickViewShown ? $('#quickViewModal') : $(document);
    // Dynamics Selectors
    this.$slider = this.isQuickViewShown ? '#quickViewModal #slider' : '#slider';
    this.$sliderSingle = this.isQuickViewShown ? '#quickViewModal #slider-single' : '#slider-single';
    this.$thumbnail = this.isQuickViewShown ? '#quickViewModal #thumbnail' : '#thumbnail';
    this.$multiPack = this.isQuickViewShown ? '#quickViewModal #multi-pack' : '#multi-pack';
    this.$multiPackContainer = $root.find('.multi-pack');
    this.$myJsTabsRelated = this.isQuickViewShown ? '#quickViewModal #related' : '#related';
    this.$myJsTabsDetail = this.isQuickViewShown ? '#quickViewModal #detail' : '#detail';
    // Common Selectors ($root)
    this.$addToCart = $root.find('.add-to-cart');
    this.$shippingContainer = $root.find('.free-shipping-container');
    this.valueShipping = this.$shippingContainer.find('.value-shipping').data('value');
    this.$stickyAddToCartSticky = $root.find('.sticky-add-to-cart').find(this.$addToCart);
    this.$footerScrollTo = $root.find('.footer-item--top');
    this.$miniCart = $('.minicart .minicart-subtotal');
    this.$ratings = $root.find('.product-rating .ratings');
    this.$feedaty = $root.find('#feedaty-carousel');
    this.$inputQuantity = $root.find('.input-quantity');
    this.$quantityWrap = $root.find('#quantity');
    this.$attributeWrap = $root.find('.attributes-items');
    this.$attributeDefault = this.$attributeWrap.find('.default-attribute');
    this.$attributeColor = this.$attributeWrap.find('.color-attribute');
    this.$inputCounter = this.$quantityWrap.find('.input-quantity');
    this.$productContainer = $root.find('.product-detail');
    this.$detailContainer = $root.find('.details-container');
    this.locale = this.$productContainer.data('locale');
    this.currency = this.$productContainer.data('currency');
    this.$multiPackSelector = $root.find('.multi-pack');
    this.$multiPackItems = $root.find('.multi-pack-items');
    this.breakpoints = parseInt(computedStyle.get('--breakpoint-xl'));
    this.document = $('html, body');
    this.triggerElement = $root.find('.product-detail .product-rating .ratings');
    this.scrollElement = $root.find('#feedaty-section');
    this.offsetHeightMenu = $('header').height();
    this.event = 'click';
    this.speed = '300';
  }

  init() {
    super.init();
    this.handlerTableDecorator();
    this.handlerTabsRelated();
    this.handlerTabsDetail();
    this.handlerAccordion();
    this.handlerMultiPack();
    this.handlerMultiPackPrice();
    this.handlerCarouselMultiPack();
    this.handlerCarouselServiceCategory();
    this.handlerCarouselBrand();
    this.handlerCarouselVariantion();
    this.handlerProgess();
    this.handlerTriggerVariantAttrDefault();
    this.handlerTriggerVariantAttrColor();
    this.handlerTriggerStickyAddToCart();
    this.stickyAddToCart();
    this.observerFeedaty();
    this.handlerDataLayer();
    if (!this.isQuickViewShown) {
      image.carouselImage(this.$slider, this.$thumbnail);
      image.zoom(this.$slider);
      image.zoom(this.$sliderSingle);
      image.carouselImageSingle(this.$sliderSingle);
      image.setVideoModal();
      image.setThumbVideoCover();
      image.initVideoCarousel();
    }
    this.handlerPanningZoom();
    this.handlerScollTo();
    this.updateQuickViewStatus();

    if (this.$multiPackSelector.length > 0) {
      listener.multiPack(this.$multiPackItems, 'change', '.input-quantity');
    }

    if (this.$shippingContainer.length > 0) {
      if (!this.$miniCart.attr('value')) return;
      const regex = /[€\s,]/g;
      const callback = function (match) {
        if (match === ',') return '.';
        return '';
      };
      const formatValueSubTotal = parseFloat(this.$miniCart.attr('value').replace(regex, callback));
      const subTotals = calculate.progress(formatValueSubTotal, this.valueShipping);
      const progressFreeShipping = this.valueShipping - formatValueSubTotal;
      const productContainer = this.isQuickViewShown ? $('#quickViewModal .product-quickview') : $('.product-detail');
      progress.build(subTotals, progressFreeShipping, productContainer);
    }

    update.setSorCostPerPrice();
  }

  updateQuickViewStatus() {
    $('#quickViewModal').on('shown.bs.modal hidden.bs.modal', () => {
      this.isQuickViewShown = $('#quickViewModal').length > 0 && $('#quickViewModal').hasClass('show');
    });
  }

  handlerCarouselMultiPack(fromHandleVariant = false, response) {
    const configs = {
      perMove: 3,
      perPage: 3,
      pagination: false,
      arrows: true,
      isNavigation: true,
      gap: 11,
      arrowPath: arrowPath,
      breakpoints: {
        640: {
          perPage: 2,
          perMove: 1,
          gap: 7,
          padding: {
            left: 0,
            right: '20px'
          }
        },
        1024: {
          perPage: 2,
          gap: 7
        }
      }
    };

    if ($('#quickViewModal').length > 0) {
      configs.arrows = false;
      configs.pagination = true;
    }

    if ($('#quickViewModal').length > 0 && $('#quickViewModal').hasClass('show')) {
      const existingSplide = $(this.$multiPack).data('splideInstance');

      if (existingSplide) {
        existingSplide.destroy(true);
      }
    }
    if (fromHandleVariant) {
      this.$multiPackContainer.removeClass('multi-pack mb-3').addClass('multipack-container').html(response.multiPackHtml);
      if (response.multiPack.length > 0) {
        if ($(this.$multiPack).length > 0) {
          new Splide(this.$multiPack, configs).mount(); // TODO: append the selector after handler variations
        }
      }
    } else {
      if (this.$multiPackContainer.length > 0) new Splide(this.$multiPack, configs).mount();
    }
  }

  handlerMultiPackPrice() {
    const productContainer = this.isQuickViewShown ? $('#quickViewModal .product-quickview') : $('.product-detail');
    if (productContainer.find('.details-top .has-multipack-price').length > 0) {
      const price = productContainer.find('.multi-pack-items.is-active').attr('data-unitprice');
      const unit = productContainer.find('.multi-pack-items.is-active').attr('data-unit-content');
      productContainer.find('.has-multipack-price .value').text(price);
      productContainer.find('.has-multipack-price .value').attr('content', unit);
      productContainer.find('.has-multipack-price').removeClass('d-none').addClass('d-flex');
    }
  }

  handlerTableDecorator() {
    $('.description-and-detail')
      .find('table')
      .each((index, elem) => {
        $(elem).removeAttr('style').addClass('table table-bordered table-striped');
        $(elem).find('tr').removeAttr('style');
        $(elem).find('td').removeAttr('style');
        if (!$(elem).closest().hasClass('table-responsive')) {
          $(elem).wrap('<div class="table-responsive" />');
        }
      });
  }

  handlerTabsRelated() {
    if ($(this.$myJsTabsRelated).length > 0) {
      const myTabs = new JsTabs({
        elm: this.$myJsTabsRelated,
        shouldScrollTabIntoView: false
      });

      myTabs.init();
    }
  }

  handlerTabsDetail() {
    if ($(this.$myJsTabsDetail).length > 0) {
      const myTabs = new JsTabs({
        elm: this.$myJsTabsDetail,
        shouldScrollTabIntoView: false
      });

      myTabs.init();
    }
  }

  handlerAccordion() {
    $(document).on('click', '.accordion-handler', (e) => {
      const $this = $(e.currentTarget);
      $this.toggleClass('open').next('.accordion-content').stop().slideToggle(300);
    });
  }

  handlerMultiPack() {
    $(document).on('click', '.product-detail .multi-pack-items', (e) => {
      e.stopPropagation();
      const $this = $(e.currentTarget);
      const $items = $('.multi-pack-items');

      $this.addClass('is-active');
      $items.not($this).removeClass('is-active');

      if ($('#quickViewModal').length > 0 && $('#quickViewModal').hasClass('show')) {
        $('#quickViewModal input.qv-input-quantity').val($this.attr('data-quantity'));
      }
      calculate.quantityMultiPack(this.$productContainer.find('.input-quantity'), $this.attr('data-quantity'), this.$inputCounter);
      math.update(this.$inputQuantity, this.maxvalue);
      const subscriptionUnitPrice = $this.data('unitprice-subscription');
      const multipackPrice = $this.data('unitprice');
      const subscriptionSave = $this.data('subscription-save');

      const subscriptionPriceContainer = $('.sor-price-container');
      if (subscriptionUnitPrice && subscriptionPriceContainer.length > 0) {
        if (subscriptionUnitPrice !== multipackPrice) {
          subscriptionPriceContainer.removeClass('d-none');
          subscriptionPriceContainer.find('.sor-price-container-value').html(subscriptionUnitPrice);
          if (subscriptionSave) {
            subscriptionPriceContainer.find('.smart-order-refill__saving-value').html(subscriptionSave);
            subscriptionPriceContainer.find('.smart-order-refill__saving-wrap:not(.no-saving)').removeClass('d-none');
          } else {
            subscriptionPriceContainer.find('.smart-order-refill__saving-wrap').addClass('d-none');
          }
        } else {
          subscriptionPriceContainer.addClass('d-none');
        }
      }
      $('body').off('product:afterAttributeSelect');
      $('body').on('product:afterAttributeSelect', (e, response) => {
        update.productPriceWithMultiPack(response.data.product);
      });
    });
  }

  handlerCarouselServiceCategory() {
    const $service = document.getElementById('service');
    if ($service) {
      new Splide($service, {
        perPage: 4,
        gap: 20,
        pagination: false,
        arrows: false,
        breakpoints: {
          640: {
            perPage: 1,
            pagination: true
          },
          1024: {
            perPage: 2
          }
        }
      }).mount();
    }
  }

  handlerCarouselBrand() {
    if (this.isQuickViewShown) return false;
    try {
      const $brand = $('.brand');
      if ($brand.length) {
        $brand.each((index) => {
          new Splide($brand[index], {
            perPage: 5,
            perMove: 5,
            gap: 20,
            pagination: false,
            arrows: false,
            breakpoints: {
              640: {
                perPage: 1,
                pagination: true
              },
              1024: {
                perPage: 2
              }
            }
          }).mount();
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  handlerCarouselVariantion() {
    const path = arrowPath;
    const configs = {
      perMove: 4,
      perPage: 4,
      pagination: false,
      arrows: true,
      isNavigation: true,
      gap: 11,
      arrowPath: path,
      breakpoints: {
        640: {
          perPage: 2,
          perMove: 2
        },
        768: {
          perPage: 3,
          perMove: 3
        }
      }
    };

    if ($('#quickViewModal').length > 0) {
      configs.arrows = false;
      configs.pagination = true;
    }

    try {
      const $attribute = $('.attribute-list:not(#multi-pack)');
      if ($attribute.length) {
        $attribute.each((index) => {
          new Splide($attribute[index], configs).mount();
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  handlerTriggerVariantAttrDefault() {
    this.$attributeDefault.on('click', (e) => {
      e.stopPropagation();
      const $this = $(e.currentTarget);
      const valueVariant = $this.data('attr-value');
      const $thisSelect = $this.parents('#attribute').find('.custom-select');
      const $attributeDefaultRow = $this.parents('#attribute').find(this.$attributeDefault);

      if (!$this.hasClass('selected')) {
        $this.addClass('selected');
        $attributeDefaultRow.not($this).removeClass('selected');
        $thisSelect.find(`option[data-attr-value="${valueVariant}"]`).prop('selected', true).trigger('change');
        this.handlerTriggerVariant();
      }
    });
  }

  handlerTriggerVariantAttrColor() {
    this.$attributeColor.on('click', () => {
      this.handlerTriggerVariant();
    });
  }

  handlerTriggerVariant() {
    $('body').on('product:afterAttributeSelect', (e, response) => {
      if (!response.error) {
        const productContainer = this.isQuickViewShown ? $('#quickViewModal .product-quickview') : $('.product-detail');
        const productData = response.data.product;
        const isQuickViewShown = $('#quickViewModal').length > 0 && $('#quickViewModal').hasClass('show');
        if (!isQuickViewShown) {
          image.carouselImageSingle(this.$sliderSingle);
          image.carousel(productData.images, productData.providerVideoUrl, productContainer);
          image.updateVideoCarousel(productData.privateLabelVideoUrls);
        }
        this.getWatermark(productData);
        this.getTopWatermark(productData);
        this.getPricePerKilo(productData, productData.idt_nascondi_prezzo_unitario);
        update.productDetails(productData, productContainer);
        this.handlerCarouselMultiPack(true, productData);
        update.productPriceWithMultiPack(productData);
        this.updateIncludedQuantityPrices(productData, productContainer);
      }
    });
  }

  updateIncludedQuantityPrices(productData, productContainer) {
    const $includedQuantityProductPrice = productContainer.find('.included-qty-productPrice');
    const $includedQuantitySorPrice = productContainer.find('.included-qty-sorPrice');

    const productPrice =
      productData.includedQuantityPrice && productData.includedQuantityPrice.productPrice
        ? productData.includedQuantityPrice.productPrice
        : null;

    const sorPrice =
      productData.includedQuantityPrice && productData.includedQuantityPrice.sorPrice ? productData.includedQuantityPrice.sorPrice : null;

    const handleIncludeQuanityPrices = function (priceData, container) {
      if (container.length > 0 && priceData) {
        container.empty().html(priceData);
        container.show();
      } else {
        container.hide();
      }
    };

    handleIncludeQuanityPrices(productPrice, $includedQuantityProductPrice);
    handleIncludeQuanityPrices(sorPrice, $includedQuantitySorPrice);
  }

  handlerProgess() {
    const valueShipping = $('.free-shipping-container').find('.value-shipping').data('value');
    $('body').on('product:afterAddToCart', (e, response) => {
      const progressCart = parseFloat(response.cart.totals.subTotal.value);
      const progressTotal = calculate.progress(progressCart, valueShipping);
      const progressFreeShipping = valueShipping - progressCart;
      if (!response.error) progress.build(progressTotal, progressFreeShipping);
    });
  }

  handlerTriggerStickyAddToCart() {
    this.$stickyAddToCartSticky.on('click', () => {
      this.$footerScrollTo.trigger('click');
    });
  }

  stickyAddToCart() {
    const scrollToTopBtn = $('.sticky-add-to-cart');
    const addToCartBtn = $('.add-to-cart').hasClass('d-none') ? $('.notifyme-button-container') : $('.add-to-cart');
    const headerHeight = $('.main-navigation').height();

    $(window).on('scroll', () => {
      const addToCartRect = addToCartBtn[0]?.getBoundingClientRect();

      if (addToCartRect && addToCartRect.bottom <= headerHeight) {
        scrollToTopBtn.addClass('is-active');
      } else {
        scrollToTopBtn.removeClass('is-active');
      }
    });
  }

  observerFeedaty() {
    if (this.$ratings.length > 0) {
      const topRatingsObserver = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          if (this.$ratings.find('[class*="fdt"]').length > 0) {
            this.$ratings.parent().removeClass('d-none');
          }
        });
      });

      topRatingsObserver.observe(this.$ratings[0], {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    if (this.$feedaty.length > 0) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          if (this.$feedaty.find('[class*="fdt"]').length > 0) {
            this.$feedaty.parent().removeClass('d-none');
          }
        });
      });

      observer.observe(this.$feedaty[0], {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }

  handlerDataLayer() {
    if (dataLayer) {
      const category = [];
      const $wrapper = $('.product-detail');

      $('.breadcrumb-item:not(:first)').each((index, elem) => {
        category.push($.trim($(elem).children().text()));
      });

      const dataLayerProduct = {
        name: $wrapper.attr('data-name'),
        id: $wrapper.attr('data-pid'),
        price: $wrapper.attr('data-price'),
        brand: $wrapper.attr('data-brand')
      };

      for (let i = 0; i < category.length; i++) {
        dataLayerProduct['item_category' + (i > 0 ? i + 1 : '')] = category[i];
      }

      dataLayer.push({
        event: 'productView',
        ecommerce: {
          detail: {
            products: [dataLayerProduct]
          }
        }
      });

      listener.dataLayerAddToCartHandler(category);
    }
  }

  handlerPanningZoom() {
    return new Zoom().init();
  }

  getWatermark(productData) {
    const watermarkType = productData.watermarks && productData.price.watermarkType ? productData.price.watermarkType : null;
    const watermarks = productData.watermarks;

    if (!productData.hasPromoCategory || !productData.activedOmnibusWatermarkPreference) {
      return image.watermark(productData['idt-watermark-image'], productData);
    } else {
      if (watermarkType) {
        if (watermarkType === 'giu prezzo') {
          return image.watermark(watermarks.giu_i_prezzi, productData, watermarkType);
        } else if (watermarkType === 'prezzo protetto') {
          return image.watermark(watermarks.prezzo_protetto, productData, watermarkType);
        }
      } else {
        return image.watermark(productData['idt-watermark-image'], productData);
      }
    }
  }

  getTopWatermark(productData) {
    const topWatermark = productData['idt-top-watermark'] ? productData['idt-top-watermark'] : false;

    if (topWatermark) {
      return image.watermark(topWatermark, productData);
    }
  }

  handlerScollTo() {
    this.triggerElement.on(this.event, (e) => {
      e.preventDefault();
      this.document.animate({ scrollTop: this.scrollElement.offset().top - this.offsetHeightMenu }, this.speed);
    });
  }

  getPricePerKilo(productData, hidePricePerKilo) {
    // eslint-disable-next-line no-useless-return
    if (!productData || !productData['idt-qfis'] || !productData['idt-cumd']) return;

    const idtQfis = productData['idt-qfis'];
    const idtCumd = productData['idt-cumd'];
    const kgPrice = `(€${(productData.price.sales.value / idtQfis).toFixed(2).replace('.', ',')}/${idtCumd})`;
    const productQfis = document.getElementsByClassName('product-qfis')[0];
    if (!productQfis) {
      const priceContainer = document.querySelector('.details-top > .prices');

      if (priceContainer) {
        priceContainer.insertAdjacentHTML(
          'beforeend',
          `<p class="product-qfis ml-2" data-idt-qfis="${idtQfis}" data-idt-cumd="${idtCumd}">${kgPrice}</p>`
        );
      }
    } else {
      productQfis.innerHTML = kgPrice;
      productQfis.setAttribute('data-idt-qfis', idtQfis);
      productQfis.setAttribute('data-idt-cumd', idtCumd);
    }

    if (hidePricePerKilo === true) {
      $('.product-qfis').hide();
    } else {
      $('.product-qfis').show();
    }
  }
}
